import React from 'react';
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import img from '../assets/images/items/group-ntf-04.png'
import Montono2 from '../components/layouts/Montono2';
import dataMontono from '../assets/fake-data/data-montono';
import Action from '../components/layouts/Action';

const Collections = () => {
    return (
        <div className='photo'>
            <Header />
            <section className="tf-section page-title">
                <div className="container">
                    <div className="col-md-12">
                        <div className="page-title__body photo">
                            <div className="block-text pt-12">
                                <h2 className="sub-title mb-20">Photography</h2>
                                <p className="fs-24 mb-33" >In a world where everyone has a camera but few  <br /> understand how to use it, hire a professional. </p>
                            </div>
                            <img className="s2" src={img} alt="Professional photography capturing authentic moments at events and gatherings" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="tf-section collection">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text center">
                                <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Photos</span></h1>
                                <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">RETAIL | COMMERCIAL | CORPORATE | EVENTS</h5>
                                <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">Lighting doesn't just illuminate subjects  <br /> it transforms them.</h3>
                            </div>
                        </div>
                    </div>
                    
                </div>
                
            </section>

            <Montono2 data={dataMontono} />
            <Action />
            <Footer />
        </div>
    );
}

export default Collections;